<template>
  <div style="min-width: 800px">
    <div class="search">
      <el-form
        :inline="true"
        :model="dataForm"
        label-width="80px"
        label-position="right"
        size="small"
        ref="searchForm"
      >
        <el-form-item label="版本号:" prop="appName">
          <el-input
            v-model="dataForm.appName"
            placeholder="app名称"
            clearable
          />
        </el-form-item>
        <el-form-item label="版本号:" prop="appVersion">
          <el-input
            v-model="dataForm.appVersion"
            placeholder="版本号"
            clearable
          />
        </el-form-item>
        <el-form-item label="设备类型:" prop="deviceType">
          <el-select
            v-model="dataForm.deviceType"
            placeholder="请选择"
            style="width: 100px"
          >
            <el-option
              v-for="value in this.$u.dict.DeviceType"
              :key="value.key"
              :label="value.val"
              :value="value.key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            @click="getDataList"
            size="small"
            icon="el-icon-search"
            type="primary"
            plain
            >查询</el-button
          >
          <el-button @click="reset" size="small" icon="el-icon-refresh"
            >清空</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="toolbar">
      <el-button
        type="primary"
        @click="addOrUpdateHandle()"
        size="medium"
        icon="el-icon-plus"
        :disabled="this.$store.state.versionControl.vuex_firm.id == undefined"
        >新增</el-button
      >
    </div>
    <el-table
      :data="dataList"
      v-loading="dataListLoading"
      stripe
      border
      style="width: 100%"
    >
      <el-table-column
        prop="deviceType"
        label="设备类型"
        width="100"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <div class="name-wrapper">
            <el-tag size="small">{{
              $u.dict.getDictName(scope.row.deviceType, $u.dict.DeviceType)
            }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="appName"
        label="app名称"
        width="150"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        prop="versionCode"
        label="版本号"
        width="150"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        prop="appVersion"
        label="版本名"
        width="150"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        width="100"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <div class="name-wrapper">
            <el-tag size="small" :type="getStatusTagType(scope.row.status)">{{
              $u.dict.getDictName(scope.row.status, $u.dict.DisabledStatus)
            }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="forceFlag"
        label="强制更新"
        width="100"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <div class="name-wrapper">
            <el-tag
              size="small"
              :type="getForUpdateTagType(scope.row.forceFlag)"
              >{{
                $u.dict.getDictName(
                  scope.row.forceFlag,
                  $u.dict.ForceUpdateFlag
                )
              }}</el-tag
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="this.$store.state.versionControl.vuex_firm.id == undefined"
        prop="firmName"
        label="所属市场"
        width="100"
        align="center"
        :show-overflow-tooltip="true"
      />
      <el-table-column prop="modifyTime" label="最后更新" align="center" />
      <el-table-column
        fixed="right"
        header-align="center"
        align="center"
        width="100"
        label="操作"
      >
        <template slot-scope="scope">
          <div>
            <el-button
              class="operate-button"
              type="text"
              @click="addOrUpdateHandle(scope.row.id)"
              >修改</el-button
            >
          </div>
          <div class="pop" id="pop">
            <el-popover placement="bottom" trigger="hover">
              <div class="more-container">
                <div
                  class="more-item"
                  @click.stop.prevent="openInfoDrawer(scope.row.id)"
                >
                  详情
                </div>
                <div
                  class="more-item"
                  @click.stop.prevent="downloadApp(scope.row.appUrl)"
                >
                  下载
                </div>
                <div class="more-item" @click.stop.prevent="del(scope.row)">
                  删除
                </div>
                <div
                  v-clipboard:copy="copyUrl"
                  v-clipboard:success="onCopySuccess"
                  v-clipboard:error="onCopyError"
                  class="more-item"
                  @click.stop.prevent="copyLink(scope.row.appUrl, $event)"
                >
                  复制外链
                </div>
              </div>
              <el-button slot="reference" type="text" class="operate-button"
                >更多</el-button
              >
            </el-popover>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-container">
      <el-pagination
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :current-page="dataForm.pageNum"
        :page-sizes="pageSizes"
        :page-size="dataForm.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
    <!--添加/修改模态框-->
    <add-or-update
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
      @refreshDataList="getDataList"
      @closeDialog="closeDialog"
    />
    <!--详情抽屉-->
    <version-info ref="versionInfo" v-if="infoVisible" />
  </div>
</template>

<script>
import AddOrUpdate from "./VersionAddOrUpdate";
import VersionInfo from "./VersionInfo";
import vControl from "@/api/version.control";
import dfs from "@/api/dfs";

export default {
  name: "versionList",
  components: {
    AddOrUpdate,
    VersionInfo
  },
  data() {
    return {
      pageSizes: [10, 20, 50],
      dataForm: {
        appVersion: "",
        pageNum: 1,
        pageSize: 10,
        deviceType: ""
      },
      copyUrl: "",
      dataList: [],
      total: 0,
      dataListLoading: false,
      addOrUpdateVisible: false,
      infoVisible: false
    };
  },
  created() {
    this.dataForm.pageSize = this.pageSizes[0];
  },
  activated() {
    //this.getDataList();
  },
  methods: {
    closeDialog() {
      this.addOrUpdateVisible = false;
    },
    //拉取列表数据
    getDataList() {
      this.dataListLoading = true;
      this.dataForm.firmId = this.$store.state.versionControl.vuex_firm.id;
      vControl
        .getPage(this.dataForm)
        .then(result => {
          this.dataList = result.data;
          this.total = result.total;
          this.dataListLoading = false;
        })
        .catch(() => {
          this.dataList = [];
          this.total = 0;
          this.dataListLoading = false;
        });
    },
    //删除
    del(rowData) {
      this.$confirm(
        `确定对[app名：${rowData.appName}]---[版本号：${rowData.appVersion}]进行操作?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        vControl.delVersion(rowData.id).then(() => {
          this.getDataList();
        });
      });
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },
    //下载app
    downloadApp(fileId) {
      dfs.download(fileId);
    },
    //打开详情页
    openInfoDrawer(id) {
      this.infoVisible = true;
      this.$nextTick(() => {
        this.$refs.versionInfo.init(id);
      });
    },
    //重置查询表单
    reset() {
      this.$refs.searchForm.resetFields();
      this.getDataList();
    },
    //获取状态的tag类型
    getStatusTagType(type) {
      if (this.$u.dict.DisabledStatus.ENABLE.key == type) {
        return "";
      }
      return "danger";
    },
    //获取强更tag类型
    getForUpdateTagType(type) {
      if (this.$u.dict.ForceUpdateFlag.NO.key == type) {
        return "";
      }
      return "danger";
    },
    // 每页数
    sizeChangeHandle(val) {
      this.dataForm.pageSize = val;
      this.dataForm.pageNum = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.dataForm.pageNum = val;
      this.getDataList();
    },
    // 复制链接方法
    copyLink(text, event) {
      this.copyUrl = dfs.generateDownloadLink(text);
    },
    onCopySuccess() {
      this.$u.message.success("复制成功");
    },
    onCopyError() {
      this.$u.message.error("复制失败");
    }
  }
};
</script>
<style scoped lang="scss">
.toolbar {
  margin-bottom: 0.5rem;
}
.operate-button {
  padding: 0;
}
.more-container {
  text-align: left;
}
.more-item {
  padding: 10px;
  color: #595959;
  &:hover {
    cursor: pointer;
    background-color: #ecf5ff;
  }
}
.page-container {
  float: right;
  margin-top: 10px;
}
</style>
